import SEO from '../components/SEO';
import PaperViewer from '../components/PaperViewer';
import { getSEOData } from '../utils/seoData';
import { PUBLICATIONS, PUBLISHED_REPOS, CLINICAL_DISCLAIMER } from '../data/ewm';
import './Narrative.css';

function Publications() {
  return (
    <div className="np-page">
      <SEO {...getSEOData('publications')} />

      {/* Hero */}
      <section className="np-hero np-hero--compact">
        <div className="container">
          <span className="np-eyebrow">Publications</span>
          <h1>The published record</h1>
          <p className="np-hero-sub">
            The framework is published, the algebra is built and tested, and every claim on this
            site is traceable to a notebook, a test or a run.
          </p>
        </div>
      </section>

      {/* Publications */}
      <section className="np-section">
        <div className="container">
          <h2 className="np-h2">Papers &amp; framework documents</h2>
          <p className="np-lead">
            Emerging World Models unifies previously separate results — lattice theory, temporal
            pyramid, DRN decomposition, holographic memory — under four principles.
          </p>

          <div className="np-grid np-grid--2">
            {PUBLICATIONS.map((p) => (
              <div key={p.id} className="np-card np-card--accent">
                <span className="np-badge">{p.type}</span>
                <h3 className="np-h3" style={{ marginTop: '6px' }}>{p.title}</h3>
                <p className="np-meta">{p.venue}</p>
                <p className="np-body">{p.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reproducible in our repositories */}
      <section className="np-section np-section--alt">
        <div className="container">
          <h2 className="np-h2">Reproducible in our own repositories</h2>
          <p className="np-lead">
            The proof-of-concept work is not a projection. Each result is traceable to a named run.
          </p>
          <ul className="np-list">
            {PUBLISHED_REPOS.map((r) => (
              <li key={r}>{r}</li>
            ))}
          </ul>

          <div className="np-card" style={{ marginTop: '30px' }}>
            <h3 className="np-h3">Open core</h3>
            <p className="np-body">
              The measurement layer and core crates are MIT-licensed. Adoption, reference
              implementations and standard-setting come from the open core; enterprise guarantees,
              packaging, hardening and support are where the commercial offering sits.
            </p>
          </div>
        </div>
      </section>

      {/* The paper itself — merged in from the former /docs page */}
      <section className="np-section">
        <div className="container">
          <h2 className="np-h2 np-h2--center">Read the paper</h2>
          <p className="np-lead np-lead--center">
            The published paper, in the in-browser viewer.
          </p>
          <PaperViewer />
        </div>
      </section>

      <section className="np-section np-section--alt">
        <div className="container">
          <div className="np-disclaimer">{CLINICAL_DISCLAIMER}</div>
        </div>
      </section>
    </div>
  );
}

export default Publications;
